module.exports = __webpack_public_path__ + "static/media/16c-01-HOME_Pasaje-3-2016-405x295mm-oleo-sobre-papel.18955553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16c/16c-01-HOME_Pasaje-3-2016-405x295mm-oleo-sobre-papel.jpg
// module id = 192
// module chunks = 0